<script setup lang="ts">
  import { ref } from 'vue';
  import Appliance from '~/components/Appliance.vue';
  import Sparepart from '~/components/Sparepart.vue';

  const activeTab = ref('appliance');

  const setActiveTab = (itemId: string | number) => {
    activeTab.value = itemId.toString();
  };
</script>

<template>
  <div :class="$gStyle('grid gap-[36px] bg-white')">
    <!-- Header -->
    <patternlib-headline heading-tag="h6">{{
      $t('title')
    }}</patternlib-headline>

    <!-- Tabs -->
    <patternlib-tabs
      @lhChange="(event) => setActiveTab(event.detail.value as string)"
      :subtle="true"
      :controlled="true"
      :class="$gStyle('mb-[36px]')"
    >
      <patternlib-tabs-item
        :active="activeTab === 'appliance'"
        itemId="appliance"
        :label="$t('general.appliance')"
      ></patternlib-tabs-item>
      <patternlib-tabs-item
        :active="activeTab === 'sparepart'"
        itemId="sparepart"
        :label="$t('general.sparepart')"
      ></patternlib-tabs-item>
    </patternlib-tabs>
  </div>
  <!-- Avtive Tab -->
  <Sparepart v-if="activeTab === 'sparepart'"></Sparepart>
  <Appliance v-else></Appliance>
</template>

<style lang="css" scoped></style>
